import React from "react"
import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	skeleton: {
		transform: "scale(1)"
	},
	cardsRow: {
		display: "flex",
		gap: "16px",
		flexWrap: "wrap" as React.CSSProperties["flexWrap"]
	},
	card: {
		flex: 1,
		minWidth: "200px",
		padding: "20px 24px",
		border: `1px solid ${colors.gray[100]}`,
		borderRadius: "8px",
		background: colors.gray[0]
	},
	section: {
		border: `1px solid ${colors.gray[100]}`,
		borderRadius: "8px",
		padding: "24px",
		background: colors.gray[0]
	},
	tableSection: {
		border: `1px solid ${colors.gray[100]}`,
		borderRadius: "8px",
		padding: "16px 24px",
		background: colors.gray[0]
	}
})

export default useStyles
